/*
 * @Description: 厂商ID余额表
 * @Author: 杨志航
 * @Date: 2026-07-06 15:32:35
 */
import React, { useState, useEffect } from 'react'
import api from 'api'
import {
  Table,
  Form,
  Input,
  Button,
  Select,
  Alert,
  Spin,
  DatePicker,
  message,
  Modal,
  Icon,
} from 'antd'
import { allTrim, filterParams, getMethodExport } from '@/utils'

const { Column } = Table
const FormItem = Form.Item
const Option = Select.Option
const dateFormat = 'YYYY-MM'

let pageSize = 10
let currentPage = 1
let searchParams = {
  limit: pageSize, 
  page: currentPage,
}

const VendorBalance = props => {
  const { getFieldDecorator, validateFields, resetFields, setFieldsValue, getFieldsValue } = props.form
  const [count, setCount] = useState(0)
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [spinLoading, setSpinLoading] = useState(false)
  const [companyList, setCompanyList] = useState([])
  const [projectList, setProjectList] = useState([])
  const [productList, setProductList] = useState([])
  const [isopen, setIsopen] = useState(false)

  useEffect(() => {
    getSearchData()
    resetParams()
    getList()
  }, [])

  const getSearchData = () => {
    Promise.all([
      api.getsysProjectChilds({ pid: 0 }),
      api.getVendorBalanceSearchData(),
    ]).then(data => {
      setProjectList(data[0])
      setCompanyList(data[1].accountList)
    }).catch(err => console.log(err))
  }

  const resetParams = () => {
    searchParams = {
      limit: pageSize, 
      page: currentPage,
    }
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  //获取列表
  const getList = () => {
    setLoading(true)
    api.getVendorBalanceList(searchParams).then(res => {
      const { list, count } = res
      setList(list)
      setCount(count)
      setLoading(false)
    }).catch(() => { setLoading(false) })
  }

  //重置
  const onReset = () => {
    resetFields()
    currentPage = 1
    resetParams()
    getList()
  }

  //提交
  const formSubmit = evt => {
    evt.preventDefault()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        vals = filterParams(vals)
        if (vals.month) {
          vals.month = vals.month.format(dateFormat)
        }
        currentPage = 1
        resetParams()
        searchParams = {...searchParams, ...vals}
        getList()
      }
    })
  }
  //点击分页
  const onChangeTable = (pagination, filters, sorter) => {
    searchParams.page = currentPage = pagination.current
    searchParams.limit = pageSize = pagination.pageSize
    getList()
  }

  // 导出
  const exportFile = () => {
    let params = JSON.parse(JSON.stringify(searchParams))
    delete params.limit
    delete params.page
    setSpinLoading(true)
    getMethodExport('/oaBalance/balanceExport', params).then(() => {
      setSpinLoading(false)
    }).catch(() => setSpinLoading(false))
  }

  const handleSync = () => {
    setSpinLoading(true)
    api.vendorBalanceSyncKingdee().then(data => {
      setSpinLoading(false)
      if (data.code === 2001) {
        Modal.confirm({
          title: '提示',
          content: data.msg,
          icon: <Icon type="check-circle" />,
        })
      } else {
        message.success('同步成功')
        onReset()
      }
    }).catch(() => setSpinLoading(false))
  }

  // 弹出日历和关闭日历的回调
  const handleOpenChange = status => setIsopen(status)
  // 拿到value并进行处理
  const handlePanelChange = value => {
    setIsopen(false)
    setFieldsValue({ month: value })
  }

  const onChangeProject = id => {
    if (id) {
      api.getsysProjectChilds({ pid: id }).then(data => {
        setProductList(data)
      })
    } else {
      setProductList([])
    }
    setFieldsValue({
      productId: undefined,
    })
  }

  return <Spin spinning={spinLoading}>
    <div className="search-doc-wrap">
      <Form onSubmit={formSubmit} {...formItemLayout} style={{ paddingTop: '10px' }}>
        <div className="form-box">
          <FormItem label="年月">
            {getFieldDecorator('month')(<DatePicker 
              open={isopen} 
              mode="month"
              placeholder="请选择"
              format={dateFormat}
              onOpenChange={handleOpenChange} 
              onPanelChange={handlePanelChange}
              style={{ width: '100%'}}
            />)}
          </FormItem>
          <FormItem label="厂商ID">
            {getFieldDecorator('vendorId')(<Input placeholder="请输入厂商ID" />)}
          </FormItem>
          <FormItem label="端口识别号">
            {getFieldDecorator('portIdentify')(<Input placeholder="请输入端口识别号" />)}
          </FormItem>
          <FormItem label="原始厂商ID">
            {getFieldDecorator('originalVendorId')(<Input placeholder="请输入原始厂商ID" />)}
          </FormItem>
          <FormItem label="客户名称">
            {getFieldDecorator('clientName')(<Input placeholder="请输入客户名称" />)}
          </FormItem>
          <FormItem label="资金主体">
            {getFieldDecorator('accountId')(<Select 
              placeholder="请选择"
              allowClear
              showSearch
              optionFilterProp="children"
            >
              {
                companyList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="项目">
            {getFieldDecorator('projectId')(<Select
              placeholder="请选择"
              allowClear
              showSearch
              optionFilterProp="children"
              onChange={onChangeProject}
            >
              {
                projectList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="产品">
            {getFieldDecorator('productId')(<Select 
              placeholder="请选择"
              allowClear
              showSearch
              optionFilterProp="children"
            >
              {
                productList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
        </div>
        <FormItem className="btns" label=" " colon={false}>
          <Button type="primary" htmlType="submit">查询</Button>
          <Button onClick={onReset}>重置</Button>
        </FormItem>
      </Form>
    </div>
    <div className="line"></div>
    <div>
      <div className="add-wrap">
        <Button type="primary" onClick={handleSync}>同步金蝶</Button>
        <Button type="primary" onClick={exportFile} style={{ marginLeft: 15 }}>数据导出</Button>
      </div>
      <Alert className="corp-count" message={`总计：${count}条数据`} type="info" showIcon />
      <Table
        size="small"
        dataSource={list}
        rowKey={(record, index) => index}
        loading={loading}
        pagination={{
          pageSize,
          total: count,
          current: currentPage,
          showQuickJumper: true,
          showSizeChanger: true,
          pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
        }}
        onChange={onChangeTable}
        scroll={{ x: 'max-content' }}
      >
        <Column 
          title="序号" 
          dataIndex="id"
          fixed="left"
          render={(text, record, index) => count - ((currentPage - 1) * pageSize + index)} 
        />
        <Column 
          title="年月" 
          dataIndex="month" 
          fixed="left" 
        />
        <Column title="厂商ID" dataIndex="vendorId" />
        <Column title="客户/代理商名称" dataIndex="clientName" />
        <Column title="客户OAID/代理商QID" dataIndex="clientId" />
        <Column title="客户/代理商金蝶编码" dataIndex="clientKingdeecode" />
        <Column title="客户类型" dataIndex="customerTypeName" />
        <Column title="资金主体" dataIndex="accountIdName" />
        <Column title="资金主体金蝶编码" dataIndex="accountKingdeecode" />
        <Column title="端口识别号" dataIndex="portIdentify" />     
        <Column title="原始厂商ID" dataIndex="originalVendorId" />
        <Column title="项目" dataIndex="projectName" />
        <Column title="产品" dataIndex="productName" />
        <Column title="产品金蝶编码" dataIndex="productKingdeecode" />
        <Column title="可用消耗" dataIndex="available" />
        <Column title="预计收款" dataIndex="colpredictprice" />     
        <Column title="补单市场价" dataIndex="addAvailable" />
        <Column title="本月消耗" dataIndex="subAVailable" />
        <Column title="更新时间" dataIndex="updateTime" />
      </Table>
    </div>
  </Spin>
}

export default Form.create()(VendorBalance)
